import type {
  FiltroRelatorio,
  PaginaAtendimentos,
  PainelRelatorios,
  TipoRelatorio,
} from '@mymaxx/shared';
import { api } from './api';
import { lerAccessToken } from './sessao';

const base = '/v1/relatorios';
const BASE_URL = (import.meta.env.VITE_API_URL as string | undefined)?.replace(/\/$/, '') ?? '';

/** Monta a query string ignorando o que está vazio. */
export function queryDoFiltro(filtro: Partial<FiltroRelatorio> & { formato?: string }): string {
  const busca = new URLSearchParams();
  for (const [chave, valor] of Object.entries(filtro)) {
    if (valor !== undefined && valor !== '' && valor !== null) busca.set(chave, String(valor));
  }
  const texto = busca.toString();
  return texto ? `?${texto}` : '';
}

/** Baixa um arquivo autenticado: precisa de fetch com Bearer, não dá para usar <a href>. */
async function baixar(caminho: string, nomePadrao: string): Promise<void> {
  const resposta = await fetch(`${BASE_URL}${caminho}`, {
    headers: { Authorization: `Bearer ${lerAccessToken() ?? ''}` },
    credentials: 'include',
  });
  if (!resposta.ok) throw new Error('Não consegui gerar o arquivo.');

  const nomeDoServidor = /filename="([^"]+)"/.exec(
    resposta.headers.get('content-disposition') ?? '',
  )?.[1];
  const blob = await resposta.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = nomeDoServidor ?? nomePadrao;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

export const relatoriosApi = {
  atendimentos: (filtro: Partial<FiltroRelatorio>) =>
    api.get<PaginaAtendimentos>(`${base}/atendimentos${queryDoFiltro(filtro)}`),

  painel: (filtro: Partial<FiltroRelatorio>) =>
    api.get<PainelRelatorios>(`${base}/painel${queryDoFiltro(filtro)}`),

  /**
   * Baixa um dos relatórios prontos com o filtro da tela — sem cursor nem limite, que são
   * só da paginação.
   */
  exportar: (tipo: TipoRelatorio, filtro: Partial<FiltroRelatorio>, formato: 'xlsx' | 'csv') => {
    const query = queryDoFiltro({ ...filtro, cursor: undefined, limite: undefined, formato });
    return baixar(`${base}/exportar/${tipo}${query}`, `${tipo}.${formato}`);
  },

  transcricao: (conversaId: string, protocolo: string) =>
    baixar(
      `${base}/atendimentos/${conversaId}/transcricao.pdf`,
      `atendimento-${protocolo.replace(/\D/g, '')}.pdf`,
    ),
};
